/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const triggerAutopilotRunDataSchema = z.object({
  planDate: z.string(),
  scheduledCount: z.number(),
  alreadyPlanned: z.boolean(),
});

export interface ITriggerAutopilotRunV1Data {
  planDate: string;
  scheduledCount: number;
  alreadyPlanned: boolean;
}

export const triggerAutopilotRunV1ResponseSchema = createApiResponseSchema(
  triggerAutopilotRunDataSchema,
) as z.ZodSchema<IAPI<ITriggerAutopilotRunV1Data>>;

export type ITriggerAutopilotRunV1Response = IAPI<ITriggerAutopilotRunV1Data>;
